export default __webpack_public_path__ + "static/media/avatar-big.71989edc.png";